import { DragOverlay } from '@dnd-kit/core';
import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import { createPortal } from 'react-dom';
import styles from './drag-overlay.module.scss';
import { useDragOverlayContext } from './DragOverlayProvider';

const cx = classNames.bind(styles);

const DragOverlayConsumer = (): ReactElement => {
  const { draggedElement } = useDragOverlayContext();

  return createPortal(<DragOverlay className={cx('body')}>{draggedElement}</DragOverlay>, document.body);
};

export default DragOverlayConsumer;
